import React, { Fragment } from 'react'
import { Box, Divider, Grid, Skeleton, Stack } from '@mui/material'
import { getToolbarShellSx } from '../toolbar/toolbarStyles'

/** When loading a DataTable with enableToolbar, pass enableToolbar: true (and darkHeader if applicable). */
export interface TableSkeletonProps {
  colNumbers: number
  darkHeader?: boolean
  enableToolbar?: boolean
  lineNumbers?: number
  lineHeight?: number
}

export const dataTableSkeletonProps = (
  props: Omit<TableSkeletonProps, 'enableToolbar'> & { enableToolbar?: boolean }
): TableSkeletonProps => ({ enableToolbar: true, ...props })

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  colNumbers,
  darkHeader = false,
  enableToolbar = false,
  lineNumbers = 15,
  lineHeight = 35,
}) => {
  return (
    <>
      {enableToolbar && (
        <Box sx={getToolbarShellSx(darkHeader ? 'tableDarkHeader' : 'table')}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flex: 1 }}>
            <Skeleton height={32} variant="rounded" width={160} />
            <Skeleton height={32} variant="rounded" width={220} />
          </Stack>
          <Stack direction="row" spacing={1}>
            <Skeleton height={32} variant="rounded" width={96} />
            <Skeleton height={32} variant="rounded" width={34} />
          </Stack>
        </Box>
      )}
      <Grid container spacing={1} sx={(theme) => ({ bgcolor: theme.palette.header, p: 1, mt: 1 })}>
        {[...Array(colNumbers)].map((_, i) => (
          <Grid key={`header-${i}`} size="grow">
            <Skeleton width={'30%'} height={35} />
          </Grid>
        ))}
      </Grid>
      <Divider />
      {[...Array(lineNumbers)].map((_, i) => (
        <Fragment key={`line-${i}`}>
          <Grid
            container
            spacing={1}
            sx={{
              mb: 1,
            }}
          >
            {[...Array(colNumbers)].map((_, i) => (
              <Grid key={i} size="grow">
                <Skeleton width={'80%'} height={lineHeight} />
              </Grid>
            ))}
          </Grid>
          <Divider />
        </Fragment>
      ))}
    </>
  )
}

export default TableSkeleton
